/**
 * Report type.
 */
export var InsightReportType;
(function (InsightReportType) {
    InsightReportType["MULTI_PAGE"] = "MULTI_PAGE";
    InsightReportType["FLAT"] = "FLAT";
})(InsightReportType || (InsightReportType = {}));
/**
 * Insight status.
 */
export var InsightStatus;
(function (InsightStatus) {
    InsightStatus["PENDING"] = "PENDING";
    InsightStatus["READY"] = "READY";
})(InsightStatus || (InsightStatus = {}));
/**
 * Insight type.
 */
export var InsightType;
(function (InsightType) {
    InsightType["NATIVE"] = "NATIVE";
    InsightType["HTML"] = "HTML";
})(InsightType || (InsightType = {}));
